<template>
  <Modal
    :width="500"
    :value="value"
    :title="$t('resources.domains.create_option_title')"
    hideActions
    @cancel="closeModal">
    <template #default>
      <div class="connect-domain-modal-wrapper">
        <div class="connect-domain-modal-select">
          <img :src="$vuetify.theme.dark ? connectDomainDark : connectDomainLight" />
          <div class="connect-domain-modal-select-content">
            <div class="title">{{ $t("resources.domains.connect_domain_title") }}</div>
            <div class="content">{{ $t("resources.domains.connect_domain") }}</div>
            <v-btn outlined class="submit-button" @click="connectDomain(false)">{{
              $t("resources.domains.select_connect_option")
            }}</v-btn>
          </div>
        </div>
        <div class="connect-domain-modal-select">
          <img :src="$vuetify.theme.dark ? connectSubdomainDark : connectSubdomainLight" />
          <div class="connect-domain-modal-select-content">
            <div class="title">{{ $t("resources.domains.connect_subdomain_title") }}</div>
            <div class="content">{{ $t("resources.domains.connect_subdomain") }}</div>
            <v-btn outlined class="submit-button" @click="connectDomain(true)">{{
              $t("resources.domains.select_connect_option")
            }}</v-btn>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
  import Modal from "@/components/custom/Modal.vue";
  import connectDomainLight from "@/assets/images/svg/connect-domain-light.svg";
  import connectDomainDark from "@/assets/images/svg/connect-domain-dark.svg";
  import connectSubdomainLight from "@/assets/images/svg/connect-subdomain-light.svg";
  import connectSubdomainDark from "@/assets/images/svg/connect-subdomain-dark.svg";

  export default {
    name: "DomainConnectModal",
    components: {
      Modal,
    },
    props: {
      value: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        connectDomainLight,
        connectDomainDark,
        connectSubdomainLight,
        connectSubdomainDark,
      };
    },
    methods: {
      closeModal() {
        this.$emit("input", false);
      },
      connectDomain(subdomain) {
        if (subdomain) {
          this.$router.push({ name: "domains_create", params: { subdomain: true } });
        } else {
          this.$router.push({ name: "domains_create" });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";
  .connect-domain-modal-wrapper {
    margin-top: 20px;
    display: flex;
    gap: 16px;

    .connect-domain-modal-select {
      flex: 1;
      border-radius: 4px;
      border: 1px solid get-color("border");

      img {
        border-radius: 3px 3px 0 0;
        width: 100%;
      }

      .connect-domain-modal-select-content {
        padding: 0 12px 12px 12px;

        .title {
          @include text-body-2-medium();
          margin-bottom: 4px;
        }
        .content {
          @include text-caption();
          color: get-color("subtitle");
        }

        .submit-button {
          margin-top: 16px;
          width: 100%;
          border-color: get-color("secondary-btn");
          color: get-color("secondary-btn");
          transition: 0.1s;

          &:hover {
            background-color: get-color("primary-10-hover");
          }
        }
      }
    }
  }
</style>
